<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m7 13.5c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8h-8v-10h-2v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8v-6h6c1.1 0 2 .9 2 2z"
    />
  </svg>
</template>
